import PropTypes from 'prop-types';
import React from 'react';

import Section from '../Section/Section';

// import './SectionList.css';

class SectionList extends React.Component {
  static propTypes = {
    assets: PropTypes.array,
    brandfolder: PropTypes.object,
    onClick: PropTypes.func.isRequired,
    onClickAttachments: PropTypes.func.isRequired
  };

  render() {
    return (
      <div className="section-list">
        {!this.hasAssets() && <p>There are no assets to insert.</p>}
        {this.props.brandfolder &&
          this.props.brandfolder.genericFileSections.map(section => {
            if (this.hasAssetForSection(section)) {
              return (
                <Section
                  key={section.id}
                  assets={this.getAssetsForSection(section)}
                  section={section}
                  onClick={this.props.onClick.bind(this)}
                  onClickAttachments={this.props.onClickAttachments.bind(this)}
                />
              );
            }
            return null;
          })}
      </div>
    );
  }

  getAssetsForSection(section) {
    return this.props.assets && this.props.assets.filter(asset => asset.section.id === section.id);
  }

  hasAssetForSection(section) {
    return this.props.assets && this.getAssetsForSection(section).length > 0;
  }

  hasAssets() {
    return this.props.assets && this.props.assets.length > 0;
  }
}

export default SectionList;



// WEBPACK FOOTER //
// ./src/components/SectionList/SectionList.js